<ion-item *mobxAutorun="{ detach: true }">
  <ng-content></ng-content>
</ion-item>
